module.exports = __webpack_public_path__ + "static/4-1200-b194bbe1807d736ad07cfbf380722b2e.png";